//react
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Mobile, PC } from "../../media/MediaQuery";

//css
import styled from "styled-components";

//component
import MyPageProduct from "../content/MyPageProduct";
import BasicBtn from "../button/BasicBtn";
import SelectBox from "../button/SelectBox";
import modalScroll from "../../utils/ModalScroll";

// img
import product from "../../assets/img/picture/product_01.jpg";
import more from "../../assets/img/icon/icon_more2.svg";

// responsive
import { M, T } from "../../utils/MT";

export default function RefundModal(props) {
    // 상품 정보
    const productDataList = [
        {
            id: 1,
            productImg: product,
            itemName: "type A530",
            price: "9,900,000",
            option: "[type A530 + smartStation™]",
            num: 1,
        },
    ];

    // 반품 사유 선택 옵션
    const [optionBoxShow, setOptionBoxShow] = useState(false);
    const [optionSelect, setOptionSelect] = useState("반품 사유를 선택해주세요");
    const optionList = ["반품 사유를 선택해주세요", "다른상품이 배송됨", "상품 파손 / 기능 오작동", "배송누락", "상품정보 상이"];

    // 텍스트 액티브 스타일
    const [textActive, setTextActive] = useState(false);

    // 완료 팝업 연결되는 버튼
    const onClickSubmit = () => {
        props.setRefundModalOpen(false);
        props.setCompleteModal(true);
    };

    return (
        <RefundModalWrap>
            <RefundModalTitle>반품 신청</RefundModalTitle>
            <OrderTableWrap>
                {/* 테이블 제목 */}
                <TabelTitle>
                    <TableList>
                        <PC>주문일자</PC> <span>2021.12.13</span>
                    </TableList>
                    <TableList>
                        <PC>주문번호</PC> <span>28000120222041</span>
                        <MoreBtn>
                            <img src={more} alt="아이콘" />
                        </MoreBtn>
                    </TableList>
                    <PC>
                        <TableList>배송비</TableList>
                    </PC>
                </TabelTitle>

                {/* 테이블 리스트 */}
                <OrderListBox>
                    {productDataList.map((item, index) => {
                        return (
                            <MyPageProduct
                                key={"productList" + index}
                                id={item.id}
                                productImg={item.productImg}
                                itemName={item.itemName}
                                price={item.price}
                                num={item.num}
                                option={item.option}
                                i={item.id}
                            />
                        );
                    })}
                    <OrderList>무료배송</OrderList>
                </OrderListBox>
            </OrderTableWrap>
            <ContentBox>
                <ContentList>
                    <ConTitle>
                        사유선택<Important>*</Important>
                    </ConTitle>
                    <SelectWrap>
                        <SelectBox
                            gray={true}
                            optionBoxShow={optionBoxShow}
                            setOptionBoxShow={setOptionBoxShow}
                            optionSelect={optionSelect}
                            setOptionSelect={setOptionSelect}
                            optionList={optionList}
                        />
                    </SelectWrap>
                </ContentList>

                <ContentList>
                    <ConTitle>사유입력</ConTitle>
                    <Textarea
                        active={textActive.length > 0}
                        onChange={(e) => {
                            setTextActive(e.target.value);
                        }}
                        placeholder=""
                    ></Textarea>
                </ContentList>
            </ContentBox>
            <RefundAddBtn>
                <BasicBtn
                    onClick={() => {
                        props.setRefundModalOpen(false);
                        modalScroll.modalClosed();
                    }}
                    text="닫기"
                    gray={true}
                    black={true}
                />
                <BasicBtn
                    text="반품 요청"
                    onClick={() => {
                        onClickSubmit(true);
                    }}
                />
            </RefundAddBtn>
        </RefundModalWrap>
    );
}

// 리뷰 모달
const RefundModalWrap = styled.div`
    width: calc(100vw * (840 / 1920));
    padding: calc(100vw * (40 / 1920));
    overflow-y: auto;
    overflow-x: hidden;

    &::-webkit-scrollbar {
        display: none;
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (840 / 1300));
        padding: calc(100vw * (40 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        padding: 0;
    }
`;
const RefundModalTitle = styled.h2`
    font-size: calc(100vw * (20 / 1920));
    text-align: center;

    margin-bottom: calc(100vw * (40 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (20 / 1300));
        margin-bottom: calc(100vw * (40 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
        margin-bottom: ${M(30)};
    }
`;

const OrderTableWrap = styled.div`
    margin-top: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        margin-top: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(20)};
    }
`;
const TabelTitle = styled.ul`
    display: flex;
    align-items: center;

    padding: calc(100vw * (20 / 1920)) 0;

    border-top: 1px solid #000;
    border-bottom: 1px solid #dddddd;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        justify-content: space-between;
        padding: ${M(20)} 0;
    }
`;

const TableList = styled.li`
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    font-family: "Noto-R";

    font-size: calc(100vw * (15 / 1920));

    & li {
        flex-shrink: 0;
    }

    &:nth-child(1) {
        width: calc(100vw * (180 / 1920));
        padding-right: calc(100vw * (20 / 1920));
    }

    &:nth-child(2) {
        width: calc(100vw * (290 / 1920));
        padding-right: calc(100vw * (20 / 1920));
    }

    &:nth-child(3) {
        font-family: "Noto-M";
    }
    & span {
        font-family: "Noto-M";
        margin-left: calc(100vw * (10 / 1920));
    }

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));

        &:nth-child(1) {
            width: calc(100vw * (180 / 1300));
            padding-right: calc(100vw * (20 / 1300));
        }

        &:nth-child(2) {
            width: calc(100vw * (290 / 1300));
            padding-right: calc(100vw * (20 / 1300));
        }

        & span {
            margin-left: calc(100vw * (10 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(15)};

        &:nth-child(1) {
            width: auto;
            padding-right: ${M(20)};
        }

        &:nth-child(2) {
            width: auto;
            /* padding-right: ${M(20)}; */
            padding-right: 0;
        }

        & span {
            margin-left: 0;
        }
    }
`;

const MoreBtn = styled.div`
    display: flex;
    align-items: center;
    width: calc(100vw * (5 / 1920));
    height: calc(100vw * (10 / 1920));
    margin-left: calc(100vw * (10 / 1920));

    & img {
        width: 100%;
        height: 100%;
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (5 / 1300));
        height: calc(100vw * (10 / 1300));
        margin-left: calc(100vw * (10 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(6)};
        height: ${M(10)};
        margin-left: ${M(10)};
    }
`;

const OrderListBox = styled.div`
    display: flex;
    align-items: center;
    border-bottom: 1px solid #dddddd;

    padding: calc(100vw * (30 / 1920)) 0;

    & > div {
        text-align: center;
    }
    & > div:nth-child(1) {
        display: flex;
        align-items: center;

        width: calc(100vw * (470 / 1920));
    }
    & > div:nth-child(2) {
        display: flex;

        width: calc(100vw * (203 / 1920));
    }
    & > div:nth-child(3) {
        width: calc(100vw * (212 / 1920));
    }

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (30 / 1300)) 0;

        & > div:nth-child(1) {
            width: calc(100vw * (470 / 1300));
        }
        & > div:nth-child(2) {
            width: calc(100vw * (203 / 1300));
        }
        & > div:nth-child(3) {
            width: calc(100vw * (212 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        flex-direction: column;
        padding: ${M(30)} 0;

        & > div:nth-child(1) {
            width: ${M(339)};
        }
        & > div:nth-child(2) {
            width: 100%;
            padding-left: ${M(98)};
        }
        & > div:nth-child(3) {
            width: ${M(212)};
        }
    }
`;
const OrderList = styled.div`
    font-size: calc(100vw * (14 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-top: ${M(10)};
        /* margin-left: ${M(20)}; */
        font-size: ${M(14)};
    }
`;

const ContentBox = styled.ul`
    padding-top: calc(100vw * (15 / 1920));

    @media screen and (max-width: 1300px) {
        padding-top: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding-top: ${M(15)};
    }
`;

const ContentList = styled.li`
    display: flex;

    &:first-child {
        /* 이거 넣으면 정렬에 문제가있는데 왜 넣었을까아? */
        /* align-items: center; */
        margin-bottom: calc(100vw * (10 / 1920));

        @media screen and (max-width: 1300px) {
            margin-bottom: calc(100vw * (10 / 1300));
        }

        @media screen and (max-width: 900px) {
            margin-bottom: ${M(10)};
        }
    }

    @media screen and (max-width: 900px) {
        flex-direction: column;
    }
`;

const ConTitle = styled.p`
    flex-shrink: 0;
    width: calc(100vw * (110 / 1920));
    font-size: calc(100vw * (15 / 1920));

    padding: calc(100vw * (11 / 1920)) 0;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (110 / 1300));
        font-size: calc(100vw * (15 / 1300));

        padding: calc(100vw * (11 / 1300)) 0;
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        text-align: left;
        font-size: ${M(15)};

        padding: ${M(11)} 0;
    }
`;

const Important = styled.span`
    font-size: calc(100vw * (14 / 1920));
    color: var(--main-color);

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (14 / 1300));
        padding: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};
        padding: 0;
    }
`;

const SelectWrap = styled.div`
    width: calc(100vw * (365 / 1920));

    & p,
    & li {
        text-align: left;
    }

    /* & p{
        color: #ddd;
    } */

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (365 / 1300));
        padding: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: 100%;
        padding: 0;
    }
`;

const Textarea = styled.textarea`
    width: 100%;
    height: calc(100vw * (80 / 1920));

    font-size: calc(100vw * (15 / 1920));

    padding: calc(100vw * (10 / 1920)) calc(100vw * (15 / 1920));
    border-radius: 5px;
    background: #fafafa;

    @media screen and (max-width: 1300px) {
        padding: calc(100vw * (20 / 1300));
        height: calc(100vw * (80 / 1300));
        font-size: calc(100vw * (15 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding: ${M(20)};
        height: ${M(131)};
        font-size: ${M(15)};
    }

    ${({ active }) => {
        return (
            active &&
            `
            border: 1px solid var(--main-color);
            background: #fff;
        `
        );
    }}
`;
const RefundAddBtn = styled.div`
    display: flex;
    align-items: center;

    width: calc(100vw * (380 / 1920));
    margin: calc(100vw * (54 / 1920)) auto calc(100vw * (20 / 1920));

    & p:first-child {
        margin-right: calc(100vw * (20 / 1920));
        font-size: calc(100vw * (15 / 1920));
    }

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (380 / 1300));
        margin: calc(100vw * (54 / 1300)) auto calc(100vw * (20 / 1300));

        & p:first-child {
            margin-right: calc(100vw * (20 / 1300));
            font-size: calc(100vw * (15 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        width: ${M(340)};
        margin: ${M(23)} auto ${M(20)};

        & p:first-child {
            margin-right: ${M(20)};
            font-size: ${M(15)};
        }
    }
`;
